import { useTranslation } from 'react-i18next'
import { Container } from '../layout/Container'
import { Accordion } from '../ui/Accordion'
import { useScrollAnimation } from '../../hooks/useScrollAnimation'
import type { FAQItem } from '../../types'

export function FAQ() {
  const { t } = useTranslation()
  const { ref, isInView } = useScrollAnimation()

  const faqs: FAQItem[] = t('faq.items', { returnObjects: true }) as FAQItem[]

  return (
    <section id="faq" className="py-24">
      <Container size="narrow">
        <div ref={ref} className="mb-16 text-center">
          <span className="text-sm font-medium uppercase tracking-wider text-accent-light">
            {t('faq.label')}
          </span>
          <h2 className="mt-4 text-3xl font-semibold text-text-primary md:text-4xl">
            {t('faq.title')}
          </h2>
        </div>

        {isInView && (
          <Accordion
            items={faqs.map((faq) => ({
              id: faq.id,
              title: faq.question,
              content: faq.answer,
            }))}
          />
        )}
      </Container>
    </section>
  )
}
